import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from './layout/MainLayout';
import Dashboard from './view/Dashboard';
import LiveStream from './view/LiveStream';
import SmileChallenge from './view/SmileChallenge';
import UnknownFaces from './view/UnknownFaces';
import MatchUnknownFace from './view/MatchUnknownFace';
import Employees from './view/Employees';
import RegisterEmployee from './view/RegisterEmployee';
import Reports from './view/Reports';
import Crossings from './view/Crossings';
import FindPerson from './view/FindPerson';
import Login from './view/Login';
import UserManagement from './view/UserManagement';
import Profile from './view/Profile';
import { AuthProvider } from './context/AuthContext';
import { PhotoRefreshProvider } from './context/PhotoRefreshContext';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';
import './styles/professional.css'

function App() {
  return (
    <AuthProvider>
      <PhotoRefreshProvider>
        <div className="App">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <MainLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="live-stream" element={<LiveStream />} />
            <Route path="smile-challenge" element={<SmileChallenge />} />
            <Route path="unknown-faces" element={<UnknownFaces />} />
            <Route path="unknown-faces/match/:unknown_id" element={<MatchUnknownFace />} />
            <Route path="employees" element={<Employees />} />
            <Route
              path="employees/register"
              element={
                <ProtectedRoute requireAdmin>
                  <RegisterEmployee />
                </ProtectedRoute>
              }
            />
            <Route path="find-person" element={<FindPerson />} />
            <Route path="reports" element={<Reports />} />
            <Route path="crossings" element={<Crossings />} />
            <Route path="profile" element={<Profile />} />
            <Route
              path="users"
              element={
                <ProtectedRoute requireAdmin>
                  <UserManagement />
                </ProtectedRoute>
              }
            />
          </Route>
        </Routes>
        </div>
      </PhotoRefreshProvider>
    </AuthProvider>
  );
}

export default App;
